import React from 'react';
import { Layout, Row, Col } from 'antd';
import { Route, Routes } from 'react-router-dom';
import { UserContextProvider } from 'src/utils/UserContext';
import Sider from 'src/components/Sider';
import { Footer, Header } from '../components';
import Dashboard from './Dashboard';
import MessageNotifications from './MessageNotifications';
import ComposeMessage from './ComposeMessage';
import Accounts from './Accounts';
import Account from './Account';
import Profile from './Profile';
import Settings from './Settings';
import Archives from './Archives';

const { Content } = Layout;

type MainLayoutProps = {
    setIsAuthenticated: (authenticated: boolean) => void;
    isAdmin: boolean;
};

function MainLayout({ setIsAuthenticated, isAdmin }: MainLayoutProps): React.ReactElement {
    return (
        <UserContextProvider>
            <Layout style={{ background: '#C9E0C9' }}>
                <Header isAuthenticated setIsAuthenticated={setIsAuthenticated} />
                <Layout
                    className="content-layout"
                    style={{ background: '#C9E0C9', padding: '10px', marginBottom: '0px', width: '100%' }}
                >
                    <Row style={{ width: '100%', background: '#C9E0C9' }}>
                        <Col
                            xs={{ span: 24 }}
                            sm={{ span: 24 }}
                            md={{ span: 8 }}
                            lg={{ span: 6 }}
                        >
                            <Sider isAdmin={isAdmin} setIsAuth={setIsAuthenticated} />
                        </Col>

                        <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 16 }} lg={{ span: 18 }}>
                            <Content
                                className="content"
                                style={{ background: '#C9E0C9', padding: '5px', width: '100%' }}
                            >
                                <div className="restricted-width">
                                    <Routes>
                                        <Route key="home" path="/*" element={<Dashboard isAdmin={isAdmin} />} />
                                        <Route key="messages" path="messages" element={<MessageNotifications />} />
                                        <Route key="messages" path="messages/:msgId" element={<MessageNotifications />} />
                                        <Route
                                            key="compose-message"
                                            path="messages/compose-message"
                                            element={<ComposeMessage isAdmin={isAdmin} />}
                                        />
                                        <Route
                                            key="settings"
                                            path="settings"
                                            element={<Settings isAdmin={isAdmin} />}
                                        />
                                        <Route key="accounts" path="accounts" element={<Accounts />} />
                                        <Route key="archives" path="archives" element={<Archives />} />
                                        <Route
                                            key="profile"
                                            path="profile/:userId"
                                            element={<Profile isAdmin={isAdmin} />}
                                        />
                                        <Route
                                            key="account"
                                            path="account/:userId"
                                            element={<Account isAdmin={isAdmin} />}
                                        />
                                        <Route
                                            key="profile-accounts"
                                            path="accounts/profile/:userId"
                                            element={<Profile isAdmin={isAdmin} />}
                                        />
                                        <Route
                                            key="profile-accounts"
                                            path="accounts/account/:userId"
                                            element={<Account isAdmin={isAdmin} />}
                                        />
                                        <Route
                                            key="profile-accounts"
                                            path="archives/account/:userId"
                                            element={<Account isAdmin={isAdmin} />}
                                        />
                                    </Routes>
                                </div>
                            </Content>
                        </Col>
                    </Row>
                </Layout>
                <Footer />
            </Layout>
        </UserContextProvider>
    );
}

export default MainLayout;
